/*

  Beginner.ts

  Show beginner help component

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjalmur Thorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { ComponentFunc, m } from "./mithril";
import { t, ts } from "./i18n";
import { glyph } from "./util";
import { IView } from "./types";

interface IAttributes {
  view: IView;
  showClose: boolean;
}

export const Beginner: ComponentFunc<IAttributes> = (initialVnode) => {
  // Show the board color guide
  const { view, showClose } = initialVnode.attrs;
  const { model, actions } = view;
  const state = model.state;
  return {
    view: () => m(".board-help",
      { title: ts("Hvernig reitirnir margfalda stigin") },
      [
        showClose ? m(".board-help-close",
          {
            title: ts("Loka þessari hjálp"),
            onclick: (ev: Event) => {
              // Close the guide and set a preference not to see it again
              if (state) {
                state.beginner = false;
                actions.setUserPref({ beginner: false });
              }
              ev.preventDefault();
            }
          },
          glyph("remove")
        ) : null,
        m(".board-colors",
          [
            m(".board-color[id='triple-word']", ["3 x", m("br"), t("orð")]),
            m(".board-color[id='double-word']", ["2 x", m("br"), t("orð")]),
            m(".board-color[id='triple-letter']", ["3 x", m("br"), t("stafur")]),
            m(".board-color[id='double-letter']", ["2 x", m("br"), t("stafur")]),
            m(".board-color[id='single-letter']", ["1 x", m("br"), t("stafur")])
          ]
        )
      ]
    )
  };
};

